export class SuccessRequest {
  data: any[] | null;
  message: string;
}
